import ReactQuill from "react-quill";

export default function Html({ value, onChange }: { value: string, onChange: (value: string) => void }) {
    return (
        <div className="quill_content">
            <ReactQuill theme="snow" value={value} onChange={onChange} />
        </div>
    );
}